import Header from './header/Header';
import React from 'react';
import Body, { ICreditDataset, IFundingDataset } from './body/Body';

import './statusSummary.scss';

const StatusSummary: React.FC<{
    brand: string;
    creditDataset: ICreditDataset;
    fundingDataset: IFundingDataset;
}> = ({ brand, creditDataset, fundingDataset }) => {
    return (
        <div className={'status-summary-widget-container'}>
            <Header />
            <Body
                brand={brand}
                creditDataset={creditDataset}
                fundingDataset={fundingDataset}
            />
        </div>
    );
};

export default StatusSummary;
